import { createAction } from 'redux-actions';

export const SetPreview = createAction('SET_PREVIEW');
